module.exports = __webpack_public_path__ + "img/add_icon_af.61f6f1e5.svg";